import { render, staticRenderFns } from "./Resguardo.vue?vue&type=template&id=58104f8c&"
import script from "./Resguardo.vue?vue&type=script&lang=js&"
export * from "./Resguardo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports